export class AttributeModel {
  id: string;
  name: string;
  value: string;
  isdisplayedontypepage: Boolean;
  isdisplayedonmodelpage: Boolean;
  constructor(data?) {
    const attributeData = data || {};
    this.id = attributeData.id; 
    this.name = attributeData.name; 
    this.value = attributeData.value; 
    this.isdisplayedonmodelpage = attributeData.isDisplayedOnModelPage;
    this.isdisplayedontypepage = attributeData.isDisplayedOnTypePage;
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/models/attribute.model.ts